import { IconCautionRoundRegular, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { useGaugebarCouponNotApplicableTextService } from '../services/useGaugebarCouponNotApplicableTextService';

type ZDSColor = React.ComponentProps<typeof Text>['color'];

export const GaugebarCouponNotApplicableTextContainer = () => {
  const { gaugebarCouponNotApplicableText } = useGaugebarCouponNotApplicableTextService();

  if (!gaugebarCouponNotApplicableText) {
    return null;
  }

  const image_url =
    gaugebarCouponNotApplicableText?.prefix_image?.webp_url?.normal ||
    gaugebarCouponNotApplicableText?.prefix_image?.url?.normal;

  const color = (gaugebarCouponNotApplicableText?.text?.color?.normal || vars.color.gray400) as ZDSColor;

  return (
    <Container>
      <StyledIconCautionRoundRegular color={color} size={16} />
      {image_url ? <StyledImage src={image_url} alt='' /> : null}
      <StyledText color={color} variant='Caption_12_Medium'>
        {gaugebarCouponNotApplicableText?.text?.text}
      </StyledText>
    </Container>
  );
};

const Container = styled.div`
  margin: 0 0 24px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 2px;
`;

const StyledImage = styled.img`
  width: auto;
  height: 14px;
`;

const StyledIconCautionRoundRegular = styled(IconCautionRoundRegular)<{ color: ZDSColor }>`
  color: ${({ color }) => color};
`;

const StyledText = styled(Text)<{ color: ZDSColor }>`
  color: ${({ color }) => color};
`;
